import './PermissionDenied.scss';

import PermissionDenied from './PermissionDenied';

export default PermissionDenied;
